export { analyticsAPIClient } from './analyticsAPIClient';
export * from './utils/types';
export * from './utils/keys';
export * from './utils/queries';
export { getGTMClientId } from './utils/clientId';
export type {
  TrackAddToCartGtmExtras,
  TrackViewGtmExtras,
} from './utils/gtmEventMapper';
